import axios from "axios";
import React, { useEffect, useState } from "react";
import { Form, Col, Row, Table } from "react-bootstrap";
import { IoMdClose } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import { BASE_URL } from "../../../../services/Api";
import { authHeader } from "../../../../services/auth-header";

const EditAraiMfgSalesEnquiry = ({ enquiryData }) => {
  const navigate = useNavigate();
  const { id, pointindex } = useParams();
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerSearch, setCustomerSearch] = useState(encodeURIComponent(" "));
  const [productOptions, setProductOptions] = useState([]);
  const [productSearch, setProductSearch] = useState(encodeURIComponent(" "));
  const [productData, setProductData] = useState([]);
  const [customerDetailsOptions, setCustomerDetailsOptions] = useState();
  const [customerNameValue, setCustomerNameValue] = useState({ value: enquiryData?.customer?.id, label: enquiryData?.customer?.companyname });
  const [customerAddressValue, setCustomerAddressValue] = useState({ value: enquiryData?.customeraddress?.id, label: enquiryData?.customeraddress?.customeraddress });

  const [enquiryDetails, setEnquiryDetails] = useState({
    enquirytype: "Manufacturing",
    enquirycategory: "International",
    enquirydate: "",
    customer: "",
    contactperson: "",
    contactno: "",
    email: "",
    customeraddress: "",
    customermaterialcode: "",
    enquiryItems: [],
  });

  console.log(enquiryData);

  const manufacturedByOptions = [
    {
      value: "Sanisure",
      label: "Sanisure",
    },
    {
      value: "TBL",
      label: "TBL",
    },
  ];

  useEffect(() => {
    const ans = enquiryData?.enquiryItems?.map((data) => ({
      product: { id: data?.product?.id },
      description: data?.product?.description,
      productremarks: data?.productremarks,
      hsnsacno: data?.hsnsacno,
      serialnumber: data?.serialnumber,
      modelnumber: data?.modelnumber,
      tagnumber: data?.tagnumber,
      moc: data?.moc,
      partno: data?.partno,
      uom: data?.uom,
      currency: data?.currency,
      quantity: data?.quantity,
    }));

    setEnquiryDetails((prevState) => ({
      ...prevState,
      enquirydate: enquiryData?.enquirydate,
      customer: { id: enquiryData?.customer?.id },
      contactperson: enquiryData?.contactperson,
      contactno: enquiryData?.contactno,
      email: enquiryData?.email,
      customeraddress: {
        id: enquiryData?.customeraddress?.id,
      },
      status: enquiryData?.status,
      customermaterialcode: enquiryData?.customermaterialcode,
      enquiryItems: ans,
      enquiryno: enquiryData?.enquiryno,
      enquirycurrency: enquiryData?.enquirycurrency,
    }));

    getCustomerAddress(enquiryData?.customer?.id, "I am calling");
  }, []);

  async function getCustomerData() {
    try {
      const response = await axios.get(`${BASE_URL}customer/page/0/10/asc/id/${customerSearch.length > 0 ? customerSearch : encodeURIComponent(" ")}`, {
        headers: authHeader(),
      });
      setCustomerOptions(
        response.data.Index
          ? response.data.Index.map((customer) => ({
            value: customer.id,
            label: customer.companyname,
          }))
          : response.data.data.map((customer) => ({
            value: customer.id,
            label: customer.companyname,
          }))
      );
    } catch (error) {
      console.log(error);
    }
  }

  async function getProductData() {
    try {
      const response = await axios.get(`${BASE_URL}product/page/international mfg/0/10/asc/id/${productSearch.length > 0 ? productSearch : encodeURIComponent(" ")}`, {
        headers: authHeader(),
      });

      console.log(response);

      setProductOptions(
        response.data.Index
          ? response.data.Index.map((product) => ({
            value: product.id,
            label: product.description,
          }))
          : response.data.data.map((product) => ({
            value: product.id,
            label: product.description,
          }))
      );

      setProductData(response.data.Index ? response.data.Index : response.data.data);
    } catch (error) {
      console.log(error);
    }
  }

  async function getCustomerDetails(id) {
    try {
      const response = await axios.get(`${BASE_URL}customer/findById/${id}`, {
        headers: authHeader(),
      });
      setEnquiryDetails({
        ...enquiryDetails,
        customer: {
          id: id,
        },
        contactperson: response.data.contactperson,
        contactno: response.data.contactno,
        email: response.data.email,
        customeraddress: response.data.address,
      });
    } catch (error) {
      console.log(error);
    }
  }

  async function getCustomerAddress(id) {
    try {
      const response = await axios.get(`${BASE_URL}customerMultipleAddress/getAddress/${id}`, {
        headers: authHeader(),
      });

      console.log(response);
      setCustomerDetailsOptions(response.data.map((data) => ({ value: data.id, label: data.customeraddress })));
    } catch (error) { }
  }

  function handleProductChange(event) {
    console.log(event.value);

    const productValue = productData.filter((data) => data.id === event.value);
    console.log(productValue);

    let product = {
      product: {
        id: productValue[0].id,
      },
      description: productValue[0].description,
      productremarks: "",
      hsnsacno: productValue[0].hsnsacno,
      serialnumber: productValue[0].serialnumber,
      modelnumber: productValue[0].modelnumber,
      tagnumber: productValue[0].tagnumber,
      moc: productValue[0].moc,
      partno: productValue[0].partno,
      uom: productValue[0].unitofmeasurement,
      quantity: "",
      currency: enquiryDetails?.enquirycurrency,
    };

    console.log(product);

    setEnquiryDetails({
      ...enquiryDetails,
      enquiryItems: [...enquiryDetails.enquiryItems, product],
    });
  }

  async function handleSubmit(event) {
    event.preventDefault();

    try {
      const response = await axios.put(`${BASE_URL}enquiry/update/${id}`, enquiryDetails, {
        headers: authHeader(),
      });

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Enquiry updated successfully!",
      });

      navigate("/salesEnquiryIndex/1");
    } catch (error) {
      console.log(error);
    }
  }

  const handleFormChange = (event, element) => {
    if (element === "manufacturedby") {
      setEnquiryDetails({
        ...enquiryDetails,
        manufacturedby: event.value,
      });
      return;
    }

    if (element === "enquirycurrency") {
      const newItems = enquiryDetails.enquiryItems.map((item) => ({
        ...item,
        currency: event.target.value, // Update currency for each item
      }));

      setEnquiryDetails({
        ...enquiryDetails,
        enquirycurrency: event.target.value, // Update selected currency
        enquiryItems: newItems, // Update all item currencies
      });
      return;
    }

    if (element === "customer") {
      getCustomerDetails(event.value);
      getCustomerAddress(event.value);
      setCustomerNameValue(event);
      setCustomerAddressValue("");
      return;
    }

    if (element === "customeraddress") {
      setEnquiryDetails({
        ...enquiryDetails,
        customeraddress: {
          id: event.value,
        },
      });

      setCustomerAddressValue(event);
      return;
    }

    const { name, value } = event.target;
    setEnquiryDetails({
      ...enquiryDetails,
      [name]: value,
    });
  };

  const handleQuantityChange = (event, index) => {
    let rows = enquiryDetails.enquiryItems;

    rows[index].quantity = event.target.value;

    setEnquiryDetails({
      ...enquiryDetails,
      enquiryItems: rows,
    });
  };

  const removeRow = (idx) => {
    const arr = enquiryDetails.enquiryItems.filter((item, index) => index !== idx);
    setEnquiryDetails({
      ...enquiryDetails,
      enquiryItems: arr,
    });
  };

  useEffect(() => {
    getCustomerData();
    getProductData();
  }, []);

  useEffect(() => {
    getCustomerData();
  }, [customerSearch]);

  useEffect(() => {
    getProductData();
  }, [productSearch]);

  console.log(enquiryDetails);
  console.log(productData);

  return (
    <div className="container">
      <br></br>

      <Form>
        <Row>
          <Col md="6">
            <Form.Group>
              <Form.Label>Enquiry No.</Form.Label>
              <Form.Control disabled type="text" name="enquirydate" value={enquiryDetails.enquiryno} onChange={handleFormChange} />
            </Form.Group>
          </Col>
          <Col md="6">
            <Form.Group>
              <Form.Label>Enquiry Date</Form.Label>
              <Form.Control type="date" name="enquirydate" value={enquiryDetails.enquirydate} onChange={handleFormChange} />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md="6">
            <Form.Group>
              <Form.Label>Customer Name</Form.Label>
              <Select
                value={customerNameValue}
                options={customerOptions}
                onChange={(event) => handleFormChange(event, "customer")}
                onInputChange={(event) => {
                  setCustomerSearch(event);
                }}
              />
            </Form.Group>
          </Col>
          <Col md="6">
            <Form.Group>
              <Form.Label>Contact Person</Form.Label>
              <Form.Control value={enquiryDetails.contactperson} disabled />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md="6">
            <Form.Group>
              <Form.Label>Contact Number</Form.Label>
              <Form.Control value={enquiryDetails.contactno} disabled />
            </Form.Group>
          </Col>
          <Col md="6">
            <Form.Group>
              <Form.Label>Email</Form.Label>
              <Form.Control value={enquiryDetails.email} disabled />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md="6">
            <Form.Group>
              <Form.Label>Customer Address</Form.Label>
              <Select value={customerAddressValue} options={customerDetailsOptions} onChange={(event) => handleFormChange(event, "customeraddress")} />
            </Form.Group>
          </Col>
          <Col md="6">
            <Form.Group>
              <Form.Label>Customer Material Code</Form.Label>
              <Form.Control type="text" name="customermaterialcode" value={enquiryDetails.customermaterialcode} onChange={handleFormChange} />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md="6">
            <Form.Group>
              <Form.Label>Currency</Form.Label>
              <Form.Select onChange={(e) => handleFormChange(e, "enquirycurrency")} name="enquirycurrency" value={enquiryDetails.enquirycurrency}>
                <option>Select Currency</option>
                <option value="$ (USD)">$ (USD)</option>
                <option value="Euro (Eurpeen Dollar)">Euro (Eurpeen Dollar)</option>
                <option value="GBP (Pounds)">GBP (Pounds)</option>
                <option value="JPY (Japanese Yen)">JPY (Japanese Yen)</option>
                <option value="₹ (INR)">₹ (INR)</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md="6">
            <Form.Group>
              <Form.Label>Status</Form.Label>
              <Form.Control type="text" name="status" value={enquiryDetails.status} disabled onChange={handleFormChange} />
            </Form.Group>
          </Col>
        </Row>

        <br></br>
        <hr></hr>

        <Row>
          <Col md="12">
            <Form.Group>
              <Form.Label>Product</Form.Label>
              <Select
                options={productOptions}
                onChange={handleProductChange}
                onInputChange={(event) => {
                  setProductSearch(event);
                }}
                value=""
              />
            </Form.Group>
          </Col>
        </Row>

        <br></br>
        <div className="table-responsive">

          <Table>
            <thead>
              <tr>
                <th style={{ width: "150px" }}>Product Description</th>
                <th>Pump Serial No.</th>
                <th>Model No.</th>
                <th>Tag No.</th>
                <th>MOC</th>
                <th>Part No.</th>
                <th>unit of measurement</th>
                <th>Currency</th>
                <th>Quantity</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {enquiryDetails.enquiryItems.map((item, index) => (
                <tr key={index}>
                  <td>
                    {item.description}
                    <Form.Control
                      as="textarea"
                      rows={2}
                      className="remarkss"
                      type="text"
                      value={item.productdescription}
                      placeholder="Enter item remarks"
                      contentEditable="true"
                      onChange={(e) => {
                        let rows = enquiryDetails.enquiryItems;
                        rows[index].productremarks = e.target.value;
                        setEnquiryDetails({
                          ...enquiryDetails,
                          enquiryItems: rows,
                        });
                      }}
                    />
                  </td>
                  <td>{item.serialnumber}</td>
                  <td>{item.modelnumber}</td>
                  <td>{item.tagnumber}</td>
                  <td>{item.moc}</td>
                  <td>{item.partno}</td>
                  <td>
                    <Form.Select
                      className="uom"
                      value={item.uom ? item.uom.toLowerCase() : ""}
                      onChange={(event) => {
                        // Update the unit of measurement in the respective item
                        const newItems = [...enquiryDetails.enquiryItems];
                        newItems[index].uom = event.target.value; // Store the selected value as is
                        setEnquiryDetails({ ...enquiryDetails, enquiryItems: newItems });
                      }}
                    >
                      <option value="">Select UOM</option>
                      <option value="bot (bottle)">Bot (Bottle)</option>
                      <option value="ctn (carton)">Ctn (Carton)</option>
                      <option value="days">Days</option>
                      <option value="ft (feet)">Ft (FEET)</option>
                      <option value="hrs (hour)">Hrs (Hour)</option>
                      <option value="kg (kilogram)">Kg (Kilogram)</option>
                      <option value="kgs.">Kgs.</option>
                      <option value="ltr (littre)">Ltr (Littre)</option>
                      <option value="mtr">Mtr</option>
                      <option value="nos (number)">Nos (Number)</option>
                      <option value="pil (pail)">Pil (Pail)</option>
                      <option value="pkt (packet)">Pkt (Packet)</option>
                      <option value="set (sets)">Set (Sets)</option>
                      <option value="pcs (pcs)">Pcs (Pcs)</option>
                    </Form.Select>
                  </td>
                  <td>{item.currency}</td>
                  <td>
                    <Form.Control
                      className="quantity" min="0"
                      value={item.quantity} type="number"
                      onChange={(event) => handleQuantityChange(event, index)} />
                  </td>
                  <td>
                    <IoMdClose onClick={() => removeRow(index)} style={{ cursor: "pointer", color: "red" }} />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        <button className="button-70" type="button" onClick={handleSubmit}>
          SUBMIT
        </button>
      </Form>
    </div>
  );
};

export default EditAraiMfgSalesEnquiry;
